import { useContext, useState } from 'react';
import { useRouter } from 'next/router';
import {
    PrimaryButton,
    SecondaryButton,
} from '@acko-tech/building-blocks.ui.button';
import { MPosContext } from 'utils/context';
import {
    getUserAccess,
    PARTNER_NAV_STATES,
    setPartnerNavState,
} from 'utils/localStorage/partnerStorage';
import * as Styles from './styles';

function LegalDocumentPendingState() {
    const router = useRouter();
    const { userAccessList } = useContext(MPosContext);
    const [isSwitchingPartner, setIsSwitchingPartner] = useState(false);

    const accessList =
        userAccessList?.length > 0 ? userAccessList : getUserAccess();
    const uniquePartnerIds = new Set(
        (accessList || [])
            .map((access: any) => access?.partner_id)
            .filter(Boolean)
    );
    const hasMultiplePartners = uniquePartnerIds.size > 1;

    const onSwitchBrand = async () => {
        setIsSwitchingPartner(true);
        try {
            setPartnerNavState(PARTNER_NAV_STATES.SELECTING);
            await router.push('/partners');
        } finally {
            setIsSwitchingPartner(false);
        }
    };

    return (
        <Styles.Wrapper>
            <Styles.TextWrapper>
                <Styles.Text>
                    We have requested your dealer to submit the bank and GST
                    details.
                </Styles.Text>
                <Styles.Text>
                    Once the dealer completes this step, you will be able to
                    start selling the plans.
                </Styles.Text>
                <Styles.Actions>
                    {hasMultiplePartners ? (
                        <Styles.ActionButton>
                            <SecondaryButton
                                onClick={onSwitchBrand}
                                disabled={isSwitchingPartner}
                            >
                                {isSwitchingPartner
                                    ? 'Switching...'
                                    : 'Switch brand'}
                            </SecondaryButton>
                        </Styles.ActionButton>
                    ) : null}
                    <Styles.ActionButton>
                        <PrimaryButton
                            onClick={() => router.push('/logout')}
                            disabled={isSwitchingPartner}
                        >
                            Logout
                        </PrimaryButton>
                    </Styles.ActionButton>
                </Styles.Actions>
            </Styles.TextWrapper>
        </Styles.Wrapper>
    );
}

export default LegalDocumentPendingState;
